module.exports = __webpack_public_path__ + "img/baner7.d631f86f.png";